import { render, staticRenderFns } from "./WatchLogList.vue?vue&type=template&id=39beb65d"
import script from "./WatchLogList.vue?vue&type=script&lang=js"
export * from "./WatchLogList.vue?vue&type=script&lang=js"
import style0 from "./WatchLogList.vue?vue&type=style&index=0&id=39beb65d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports